import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { TaskTimerFeatureComponent } from './task-timer-feature/task-timer-feature.component';

const log = new LoggingService();

export const TaskTimerRoute: Ng2StateDeclaration = {
    name: 'tasktimer',
    url: '/tasktimer',
    data: { requiresAuth: true },

    component: TaskTimerFeatureComponent
};
